import { ChevronRight } from 'lucide-react'
import { Fragment } from 'react'

export interface CampaignBreadcrumbEntry {
	label: string
	/** Present for every entry except the current (final) one. */
	href?: string
}

export interface CampaignBreadcrumbProps {
	trail: CampaignBreadcrumbEntry[]
	onNavigate: (href: string) => void
}

/** Feature-local page-level breadcrumb. Its trail comes entirely from props. */
export function CampaignBreadcrumb({ trail, onNavigate }: CampaignBreadcrumbProps) {
	return (
		<nav
			aria-label="Breadcrumb"
			className="flex min-w-0 max-w-full flex-wrap items-center gap-1.5 text-sm text-ds-text-muted"
		>
			{trail.map((entry, index) => (
				<Fragment key={`${entry.label}-${index}`}>
					{index > 0 && <ChevronRight className="h-3.5 w-3.5 text-ds-text-subtle" aria-hidden="true" />}
					{entry.href ? (
						<button type="button" onClick={() => onNavigate(entry.href as string)} className="hover:text-ds-text">
							{entry.label}
						</button>
					) : (
						<span aria-current="page" className="min-w-0 truncate text-ds-text">
							{entry.label}
						</span>
					)}
				</Fragment>
			))}
		</nav>
	)
}
